<template>
 <detail :screen="screen" :w="w" :id="id" :y="y" :button-title="y == 'isYY'?'立即预约':'立即购买'" :url="url"></detail>
</template>

<script type="text/javascript">

import Detail from '@/components/Detail'

export default {
    components: {
        Detail
    },
    props: {
        screen:{
            type: Object,
            default: () => {}
        },
        id: {
            type: String
        },
        w: {
            type: String
        },
        y:{
          type: String
        }
    },
    data() {
        return {
          url: {
              get: SZH.assets.api + "/Order/GetProductInfo",
              canBuy: SZH.assets.api + '/Order/GetCanBuyProduct'
          },
        }
    },
    methods: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
        sessionStorage.setItem("product-type", "standard");
        sessionStorage.removeItem("OrderKey");
    },
    watch: {}
}
</script>

<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Detail/Detail.vue